
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mass-add",
      function () {
        return require("private-next-pages/mass-add.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mass-add"])
      });
    }
  